export default "__VITE_PUBLIC_ASSET__2923ad5b__"